module.exports = __webpack_public_path__ + "img/暴雨-大暴雨.51e0c48f.png";